import { Typography } from 'seagull';
import { AnchorIcon } from 'seagull/icons';
import styles from "./MapServicesModal.module.scss";
import { getAccountingDetails } from "../accounting.utils";
import { serviceTemplateModel } from "../../../models";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const columnDefs = hideType => [{
  width: 400
},
// Anchor service
{
  width: 400
},
// QuickBooks item names
{
  width: 130
},
// Status
{
  width: hideType ? 0 : 130
} // Type
];
export const getHeaderItems = (accounting, hideType) => [{
  value: /*#__PURE__*/_jsxs("div", {
    className: styles.columnHeader,
    children: [/*#__PURE__*/_jsx(AnchorIcon, {
      className: styles.icon
    }), /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph2",
      children: "Anchor service name"
    })]
  })
}, {
  value: /*#__PURE__*/_jsx("div", {
    className: styles.columnHeader,
    children: /*#__PURE__*/_jsxs(Typography, {
      variant: "paragraph2",
      children: [getAccountingDetails(accounting).fullName, " service name"]
    })
  })
}, ...(hideType ? [] : [{
  value: /*#__PURE__*/_jsx("div", {
    className: styles.columnHeader,
    children: /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph2",
      "data-testid": "service-template-type-header",
      children: "Type"
    })
  })
}]), {
  value: 'Status'
}];
export function getSearchedServicesAndFilteredOptions(_ref) {
  let {
    services,
    search,
    statusFilters,
    accounting
  } = _ref;
  const searchFilteredServices = services.filter(service => applySearch({
    search,
    service
  }));
  const serviceFilterOptions = getServiceFilterOptions({
    services: searchFilteredServices,
    accounting
  });
  const filteredServices = searchFilteredServices.filter(service => applyServiceFilterMappingStatus({
    filters: statusFilters,
    service,
    accounting
  }));
  return {
    filteredServices,
    serviceFilterOptions
  };
}
export function applySearch(_ref2) {
  let {
    search,
    service
  } = _ref2;
  const normalizedSearch = search ? search.trim().toLowerCase() : search;
  const serviceName = service.name.toLowerCase();
  return !normalizedSearch || "".concat(serviceName).includes(normalizedSearch);
}
export function applyServiceFilterMappingStatus(_ref3) {
  let {
    filters,
    service,
    accounting
  } = _ref3;
  return filters.length === 0 || filters.some(status => status === 'mapped' && serviceTemplateModel.integratedId({
    serviceTemplate: service,
    accounting
  }) != null || status === 'notMapped' && serviceTemplateModel.integratedId({
    serviceTemplate: service,
    accounting
  }) == null);
}
export function getServiceFilterOptions(_ref4) {
  let {
    services,
    accounting
  } = _ref4;
  return services.reduce((acc, service) => {
    const status = getServiceMappingStatus(service, accounting);
    const existingStatusEntry = acc.findIndex(option => option.value === status);
    if (existingStatusEntry >= 0) {
      acc[existingStatusEntry].counter = (acc[existingStatusEntry].counter || 0) + 1;
    } else {
      acc.push({
        value: status,
        counter: 1,
        label: status === 'mapped' ? 'Yes' : 'No'
      });
    }
    return acc;
  }, []);
}
export function getServiceMappingStatus(service, accounting) {
  return serviceTemplateModel.integratedId({
    serviceTemplate: service,
    accounting
  }) ? 'mapped' : 'notMapped';
}